import { useNavigate } from 'react-router-dom';
import { useAppTrialAccess } from '../useAppTrialAccess';
import ActivarSuscripcionBanner from '../ActivarSuscripcionBanner';
import '../premiumLanding.css';

export default function DevssoftChatLandingPage() {
  const navigate = useNavigate();
  const { isAuthenticated, canRequestTrial, startTrial } = useAppTrialAccess('devssoft_chat_v1');

  return (
    <div className="pl">
      <section className="pl-hero">
        <div className="pl-wrap">
          <p className="pl-kicker">Premium · IA Empresarial</p>
          <h1>DevsSoft Chat</h1>
          <p>
            Consulta y analiza tus negocios con IA. Conecta Inventario y POS Retail con respuestas
            accionables, comparaciones automáticas y trazabilidad de fuentes. Solo lectura.
          </p>
          <div className="pl-cta-row">
            {canRequestTrial ? (
              <button type="button" className="pl-btn pl-btn-accent" onClick={startTrial}>
                Activar prueba gratis
              </button>
            ) : !isAuthenticated ? (
              <button type="button" className="pl-btn pl-btn-primary" onClick={() => navigate('/login')}>
                Iniciar sesión
              </button>
            ) : (
              <ActivarSuscripcionBanner appKey="devssoft_chat_v1" appName="DevsSoft Chat" />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
